import { render, staticRenderFns } from "./SummaryLink.vue?vue&type=template&id=1245a38e&"
import script from "./SummaryLink.vue?vue&type=script&lang=js&"
export * from "./SummaryLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports